<div class="header-bar">
  <div class="header-left">
    <div class="header-text">{{ internal ? "Internal Flows" : "Flow Library"}}</div>
    <div class="divider"></div>
    <button mat-button class="icon-btn" (click)="changeLayout('list')">
      <svg-icon
        src="assets/svg/list.svg"
        [svgStyle]="{
          'width.px': '26.5',
          'height.px': '23.5'
        }"
        [svgClass]="selectedView === 'list' ? 'lightGreen' : 'grey'"
      ></svg-icon>
    </button>
    <button mat-button class="icon-btn" (click)="changeLayout('grid')">
      <svg-icon
        src="assets/svg/grid.svg"
        [svgStyle]="{
          'width.px': '26.5',
          'height.px': '26.5'
        }"
        [svgClass]="selectedView === 'grid' ? 'lightGreen' : 'grey'"
      ></svg-icon>
    </button>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
    <ng-container *ngIf="selectedView === 'grid'">
      <div class="divider"></div>
      <div class="sort-by">
        <div class="text">Sort by</div>
        <lhpe-select
          [options]="sortColumns"
          [formGroup]="sortFormGroup"
          controlName="sort"
        >
        </lhpe-select>
      </div>
    </ng-container>
    <div class="divider"></div>

    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input matInput type="text" [formControl]="searchValueControl" />
      </mat-form-field>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button
      *ngIf="hasFlowsWrite"
      mat-button
      color="lightGreen"
      (click)="createFlow()"
    >
      Create {{ internal ? "Internal Flow" : "Flow"}} 
    </button>
  </div>
</div>
<div class="flow-library">
  <div class="flow-grid-view" *ngIf="selectedView === 'grid'">
    <div *ngFor="let flow of filteredFlows" class="container flow-container">
      <div class="container-header no-bottom-border">
        <div class="start-pause">
          <svg-icon
            class="start"
            src="assets/svg/play-grid.svg"
            [svgClass]="flow.disabled ? 'lightGrey' : 'lightGreen'"
            (click)="changeFlowDisabled(flow, false)"
          ></svg-icon>
          <svg-icon
            class="pause"
            src="assets/svg/pause-grid.svg"
            [svgClass]="flow.disabled ? 'lightGreen' : 'lightGrey'"
            (click)="changeFlowDisabled(flow, true)"
          ></svg-icon>
        </div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="flowMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu class="mat-menu-elaphant vertical-menu" #flowMenu="matMenu">
            <ng-container>
              <button
                *ngIf="flow.disabled && hasWrite"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="changeFlowDisabled(flow, false)"
              >
                <svg-icon src="assets/svg/play-white.svg"></svg-icon>
                <span>Play flow</span>
              </button>
              <button
                *ngIf="!flow.disabled && hasWrite"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="changeFlowDisabled(flow, true)"
              >
                <svg-icon src="assets/svg/pause-white.svg"></svg-icon>
                <span>Pause flow</span>
              </button>
              <button
                *ngIf="hasWrite"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="editFlow(flow)"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  [svgStyle]="{
                    'width.px': '21.441',
                    'height.px': '21.441'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Edit flow</span>
              </button>
              <button
                *ngIf="hasReport"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="goToReport(flow)"
              >
                <svg-icon src="assets/svg/performance-white.svg"></svg-icon>
                <span>Performance report</span>
              </button>
              <button
                *ngIf="hasDelete"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="deleteFlow(flow)"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '22.5',
                    'height.px': '22.298'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Delete flow</span>
              </button>
            </ng-container>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <div class="container-heading">{{ flow.name }}</div>
        <div class="container-row">
          <div class="question">Created:</div>
          <div class="answer">
            <ng-container *ngIf="flow.created_at">
              {{ formatDate(flow.created_at) }}
            </ng-container>
            <ng-container *ngIf="!flow.created_at"> - </ng-container>
          </div>
        </div>
        <div class="container-row">
          <div class="question">Created by:</div>
          <div class="answer">
            {{ flow.created_by_user.last_name ? flow.created_by_user.last_name + ", " + flow.created_by_user.first_name : "-" }}
          </div>
        </div>
        <div class="container-row">
          <div class="question">Last modified:</div>
          <div class="answer">
            <ng-container *ngIf="flow.updated_at">
              {{ formatDate(flow.updated_at) }}
            </ng-container>
            <ng-container *ngIf="!flow.updated_at"> - </ng-container>
          </div>
        </div>
        <div class="container-row">
          <div class="question">Modified by:</div>
          <div class="answer">
            {{ flow.updated_by_user.last_name ? flow.updated_by_user.last_name + ", " + flow.updated_by_user.first_name : "-" }}
          </div>
        </div>
        <div class="container-row">
          <div class="question">Conversions:</div>
          <div class="answer">
            {{ flow.conversions }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flow-list-view" *ngIf="selectedView === 'list'">
    <div class="container flow-list-container">
      <div class="container-header no-bottom-border">
        <div class="text">Flows</div>
      </div>

      <div
        class="container-content"
        lhpeElementLoader
        #flowsElementLoader="elementloader"
      >
        <table #flowTable mat-table [dataSource]="flowsDataSource" matSort>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Flow Name</th>
            <td mat-cell *matCellDef="let row">
              {{ row.name ? row.name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="trigger_name">
            <th mat-header-cell *matHeaderCellDef>Trigger</th>
            <td mat-cell *matCellDef="let row">
              {{ row.trigger_name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.created_at">
                {{ formatDate(row.created_at) }}
              </ng-container>
              <ng-container *ngIf="!row.created_at"> - </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="creator_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Created by
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.created_by_user ? row.created_by_user.last_name + ", " + row.created_by_user.first_name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="modified_at">
            <th mat-header-cell *matHeaderCellDef>Last modified</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.updated_at">
                {{ formatDate(row.updated_at) }}
              </ng-container>
              <ng-container *ngIf="!row.updated_at"> - </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="modified_by_name">
            <th mat-header-cell *matHeaderCellDef>Modified by</th>
            <td mat-cell *matCellDef="let row">
              {{ row.updated_by_user ? row.updated_by_user.last_name + ", " + row.updated_by_user.first_name : "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="conversions">
            <th mat-header-cell *matHeaderCellDef class="center">Conversions</th>
            <td mat-cell *matCellDef="let row" class="center">
              {{ row.conversions }}
            </td>
          </ng-container>

          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="options-cell">

              <div *ngIf="rowExpired(row.end_date)" style="padding-right: 4px">
                <svg-icon
                  class="start"
                  src="assets/svg/time-clock-circle.svg"
                  [svgStyle]="{
                    'width.px': '18',
                    'height.px': '18'
                  }"
                ></svg-icon>
              </div>
              

              <div class="start-pause" *ngIf="!rowExpired(row.end_date)">
                <svg-icon
                  class="start"
                  src="assets/svg/play.svg"
                  [svgClass]="row.disabled ? 'lightGrey' : 'lightGreen'"
                  [svgStyle]="{
                    'width.px': '19.25',
                    'height.px': '19.25'
                  }"
                  (click)="changeFlowDisabled(row, false)"
                ></svg-icon>
                <svg-icon
                  class="pause"
                  src="assets/svg/pause.svg"
                  [svgClass]="row.disabled ? 'lightGreen' : 'lightGrey'"
                  [svgStyle]="{
                    'width.px': '19.25',
                    'height.px': '19.25'
                  }"
                  (click)="changeFlowDisabled(row, true)"
                ></svg-icon>
              </div>

              <button
                *ngIf="hasReport"
                mat-button
                (click)="goToReport(row)"
                class="icon-btn"
              >
                <svg-icon src="assets/svg/performance.svg"></svg-icon>
              </button>

              <div *ngIf="!hasReport" class="empty-btn-space"></div>

              <button
                *ngIf="hasWrite"
                mat-button
                (click)="editFlow(row)"
                class="icon-btn"
              >
                <svg-icon
                  src="assets/svg/pencil.svg"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              <div *ngIf="!hasWrite" class="empty-btn-space"></div>
              <button
                *ngIf="hasDelete"
                class="icon-btn"
                mat-button
                (click)="deleteFlow(row)"
              >
                <svg-icon
                  src="assets/svg/trashcan.svg"
                  [svgStyle]="{
                    'width.px': '15.25',
                    'height.px': '16.204'
                  }"
                  svgClass="lightBlue"
                ></svg-icon>
              </button>
              <div *ngIf="!hasDelete" class="empty-btn-space"></div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage" (page)="onPageChange($event)"></mat-paginator>
      </div>
    </div>
  </div>
</div>
